const getters = {
  items: state => state.user.items,
  user: state => state.user.user,
  
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  theme: state => state.app.theme,

    requestLoading: state => state.app.requestLoading,
   // 获取完整的用户信息
  currentUser: state => state.userInfo.userInfo,
    // 用户是否已登录（根据oid或name判断）
    // isLoggedIn: (state) => !!(state.userInfo.oid || state.userInfo.name),
    // // 用户角色列表
    // userRoles: (state) => state.userInfo.roles,
    // // 检查用户是否具有某个特定角色
    // hasRole: (state) => (roleName) => state.userInfo.roles.includes(roleName)

};
export default getters;
